import { Module } from '@nu-art/ts-common';
import { ApiDef_Archiving } from '@nu-art/thunderstorm-shared';
import { apiWithBody, apiWithQuery } from '../../core/typed-api.js';
class ModuleFE_Archiving_Class extends Module {
    vv1;
    constructor() {
        super();
        this.vv1 = {
            hardDeleteAll: apiWithQuery(ApiDef_Archiving.vv1.hardDeleteAll),
            hardDeleteUnique: apiWithBody(ApiDef_Archiving.vv1.hardDeleteUnique),
            getDocumentHistory: apiWithQuery(ApiDef_Archiving.vv1.getDocumentHistory)
        };
    }
}
export const ModuleFE_Archiving = new ModuleFE_Archiving_Class();
//# sourceMappingURL=ModuleFE_Archiving.js.map